import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MaterialsName.css';
import ManagerSidebar from '../components/Sidebar/ManagerSidebar';

const API_URL = 'https://ikaze-thouse-backend.vercel.app/api/MaterialNames';

export default function MaterialsName() {
  const [materials, setMaterials] = useState([]);
  const [materialName, setMaterialName] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // ================= PAGINATION ADDED =================
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  // ====================================================

  const fetchMaterials = async () => {
    try {
      const res = await axios.get(API_URL);
      setMaterials(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchMaterials();
  }, []);

  const openForm = () => {
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
    setEditingId(null);
    setMaterialName('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        await axios.put(`${API_URL}/${editingId}`, {
          material_name: materialName
        });
      } else {
        await axios.post(API_URL, {
          material_name: materialName
        });
      }

      closeForm();
      fetchMaterials();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.m_id);
    setMaterialName(item.material_name);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this material?")) {
      await axios.delete(`${API_URL}/${id}`);
      fetchMaterials();
    }
  };

  // ================= PAGINATION LOGIC =================
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMaterials = materials.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(materials.length / itemsPerPage);

  const goToPage = (page) => {
    setCurrentPage(page);
  };
  // ====================================================

  return (
    <div className="layout">

      <ManagerSidebar />

      <div className="content">

        {/* TABLE ONLY */}
        <div className="card tableCard">

          <div className="topbar">
            <h2>Materials Management</h2>

            <button className="addBtn" onClick={openForm}>
              + Add Material
            </button>
          </div>

          <h3>Materials List</h3>

          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Material</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {currentMaterials.map((m) => (
                <tr key={m.m_id}>
                  <td>#{m.m_id}</td>
                  <td>{m.material_name}</td>
                  <td>
                    <button className="edit" onClick={() => handleEdit(m)}>
                      Edit
                    </button>

                    <button className="delete" onClick={() => handleDelete(m.m_id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* ================= PAGINATION UI ================= */}
          <div className="pagination">

            <button
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => goToPage(index + 1)}
                className={currentPage === index + 1 ? "activePage" : ""}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>

          </div>
          {/* ================================================= */}

        </div>

      </div>

      {/* MODAL FORM */}
      {showForm && (
        <div className="modalOverlay">
          <div className="modal">

            <h3>{editingId ? "Update Material" : "Add Material"}</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Material name..."
                value={materialName}
                onChange={(e) => setMaterialName(e.target.value)}
                required
              />

              <div className="btnRow">
                <button type="submit" className="primary">
                  {editingId ? "Update" : "Save"}
                </button>

                <button type="button" className="secondary" onClick={closeForm}>
                  Cancel
                </button>
              </div>
            </form>

          </div>
        </div>
      )}

    </div>
  );
}